import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Card, Button, Modal, Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Stepper from '../../component/stepper/Stepper';
import ChangeTemplateLayout from '../../component/changetemplate/ChangeTemplateLayout';
import { setItem, getItem } from '../../config/localStorage';
import { axiosInstance } from '../../config/ConfigInfo';
import PreviewTemplate from '../../component/preview/PreviewTemplate';
import SpinLoader from '../../component/loader/SpinLoader';

function Education() {
    const educationData = getItem('educationData') ? JSON.parse(getItem('educationData')) : '';
    const chossenLevelOfEducation = getItem('levelOfEducation');
    const [choosenEducationType, setChoosenEducationType] = useState(chossenLevelOfEducation ?? 'in-school');

    const [educationTabOne, setEducationTabOne] = useState(true);
    const [educationTabTwo, setEducationTabTwo] = useState(false);
    const [educationTabThree, setEducationTabThree] = useState(false);

    const [loader, setLoader] = useState(true);

    const [education, setEducation] = useState(
        educationData ??
        [{
            schoolName: '',
            schoolLocation: '',
            schoolDegree: '',
            schoolFieldOfStudy: '',
            schoolYearOfCompletion: '',
        }]
    );

    const navigate = useNavigate();
    const location = useLocation();

    /** move to poppin application start */
    const POPPIN_JOB_BASE_URL = process.env.REACT_APP_POPPIN_JOB_BASE_URL;
    const moveToPoppinAppJobForm = () => {
        window.location.href = POPPIN_JOB_BASE_URL + 'user/job-seeker-form';
    }
    /** move to poppin application end */

    useEffect(() => {

        if (location.state === null) {
            navigate('/resume-builder');
        } else {
            if (location.state.educationTabOne === true) {
                educationFieldsOne();
            }
            if (location.state.educationTabThree === true) {
                educationFieldsThree();
            }
        }

        /** call API to fetch the education data start */
        (async () => {
            if (educationData === '') {
                try {
                    const { data } = await axiosInstance.get("api/JobSeeker/GetJobSeekerEducationDetails");
                    const formattedData = data.data.map(item => ({
                        schoolName: item.collegeName,
                        schoolLocation: 'N/A',
                        schoolDegree: item.degreeName,
                        schoolFieldOfStudy: item.fieldOfStudyName,
                        schoolYearOfCompletion: item.yearofCompletion
                    }));
                    setEducation(formattedData);
                    setLoader(false);
                } catch (error) {
                    setLoader(false);

                }
            } else {
                setLoader(false);
            }
        })()
        /** call API to fetch the education data end */

    }, []);

    /** to handle next and previous click button start */

    const BackExperiencePage = () => {
        navigate('/experience', { state: { experienceTabThree: true } });
    }

    const formValidation = (education) => {
        let data = [...education];
        let validationCheck = true;

        for (let i = 0; i < data.length; i++) {
            if (data[i].schoolName === '') {
                data[i].errorSchoolNameMsg = 'Enter the school name.';
                validationCheck = false
            } else {
                data[i].errorSchoolNameMsg = ''
            }

            if (data[i].schoolLocation === '') {
                data[i].errorSchoolLocationMsg = 'Enter the school location.';
                validationCheck = false
            } else {
                data[i].errorSchoolLocationMsg = ''
            }

            if (data[i].schoolDegree === '') {
                data[i].errorSchoolDegreeMsg = 'Enter the degree.';
                validationCheck = false
            } else {
                data[i].errorSchoolDegreeMsg = ''
            }

            if (data[i].schoolFieldOfStudy === '') {
                data[i].errorSchoolFieldOfStudyMsg = 'Enter the field of study.';
                validationCheck = false
            } else {
                data[i].errorSchoolFieldOfStudyMsg = ''
            }
            
            if (data[i].schoolYearOfCompletion === '') {
                data[i].errorSchoolYearOfCompletionMsg = 'Select the year of completion.';
                validationCheck = false
            } else {
                data[i].errorSchoolYearOfCompletionMsg = ''
            }
        }
        setEducation(data);
        return validationCheck;
    }

    const MovetoSkillPage = () => {
        const checkValidation = formValidation(education);
        if (checkValidation) {
            const jsonData = JSON.stringify(education);
            setItem('educationData', jsonData);
            navigate('/skill', { state: { skillFieldsOne: true } });
        }
    }

    /** add more education here  */
    const handelEducationAdd = () => {
        const newExperience = [...education,
        {
            schoolName: '',
            schoolLocation: '',
            schoolDegree: '',
            schoolFieldOfStudy: '',
            schoolYearOfCompletion: '',
        },
        ];
        setEducation(newExperience);
    }

    /** onchange handle here  */
    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const updatedEducation = [...education];
        updatedEducation[index][name] = value;
        setEducation(updatedEducation);
        validationOnChange(name, updatedEducation);
    };

    const validationOnChange = (name, updatedEducation) => {
        let data = [...updatedEducation];
        for (let i = 0; i < data.length; i++) {
            if (name === "schoolName" && data[i].schoolName !== '') {
                delete data[i].errorSchoolNameMsg;
            }
            if (name === "schoolLocation" && data[i].schoolLocation !== '') {
                delete data[i].errorSchoolLocationMsg;
            }
            if (name === "schoolDegree" && data[i].schoolDegree !== '') {
                delete data[i].errorSchoolDegreeMsg;
            }
            if (name === "schoolFieldOfStudy" && data[i].schoolFieldOfStudy !== '') {
                delete data[i].errorSchoolFieldOfStudyMsg;
            }
            if (name === "schoolYearOfCompletion" && data[i].schoolYearOfCompletion !== '') {
                delete data[i].errorSchoolYearOfCompletionMsg;
            }
        }
        return data;
    }

    /** remove education here */
    const handelEducationRemove = (index) => {
        const newEducation = [...education];
        newEducation.splice(index, 1);
        setEducation(newEducation);
    }

    /** to handle next and previous click button end    */

    const onOptionChange = (e) => {
        setChoosenEducationType(e.target.value);
    }

    const educationFieldsOne = (e) => {
        setEducationTabOne(true);
        setEducationTabTwo(false);
        setEducationTabThree(false);
    }

    const educationFieldsTwo = (e) => {
        setEducationTabOne(false);
        setEducationTabTwo(true);
        setEducationTabThree(false);
    }

    const educationFieldsThree = (e) => {
        setEducationTabOne(false);
        setEducationTabTwo(false);
        setEducationTabThree(true);
        setItem('levelOfEducation', choosenEducationType);
    }

    const startYear = 1960;
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
    }

    return (
        <>
            <section className='main-section padding-top-bottom education-main-section'>

                <Container>
                    <Row>
                        <Col md={12}>
                            <Card className='education-card-option'>
                                <Stepper pagenumber='3' />

                                {
                                    educationTabOne ?
                                        < Card.Body className='education-part-two-main'>
                                            <Row>
                                                <Col md={9} className='education-part-two-text-outer'>
                                                    <div className='education-part-two-text'>
                                                        <h2>Education</h2>
                                                        <p>List your educational background, including degrees, institutions, and graduation dates. Highlight any relevant coursework, honors, or extracurricular activities that align with the job you are applying for.</p>
                                                    </div>
                                                </Col>
                                                <Col md={3}>
                                                    <ChangeTemplateLayout />
                                                </Col>
                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={BackExperiencePage}>Back</Button>
                                                                <PreviewTemplate />
                                                                <Button className='my-next-btn button-green float-end' onClick={educationFieldsTwo}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                                {
                                    educationTabTwo ?
                                        <Card.Body>
                                            <Row>
                                                <Col md={12}>
                                                    <Col md={12} className='education-header-part'>
                                                        <Card.Title>What best describes your level of education</Card.Title>
                                                        <Card.Text>Select the best option and we'll help structure your education section.</Card.Text>

                                                    </Col>
                                                    <Col md={12}>
                                                        <div className='education-main'>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="in-school"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="in-school"
                                                                    checked={choosenEducationType === "in-school"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="in-school" className={`${choosenEducationType === "in-school" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">In School</div>
                                                                </label>
                                                            </div>
                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="high-school"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="high-school"
                                                                    checked={choosenEducationType === "high-school"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="high-school" className={`${choosenEducationType === "high-school" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">High School</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="diploma-certificate"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="diploma-certificate"
                                                                    checked={choosenEducationType === "diploma-certificate"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="diploma-certificate" className={`${choosenEducationType === "diploma-certificate" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Diploma Certificate</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="internship-training"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="internship-training"
                                                                    checked={choosenEducationType === "internship-training"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="internship-training" className={`${choosenEducationType === "internship-training" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Internship Training</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="associates"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="associates"
                                                                    checked={choosenEducationType === "associates"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="associates" className={`${choosenEducationType === "associates" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Associates</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="bachelors"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="bachelors"
                                                                    checked={choosenEducationType === "bachelors"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="bachelors" className={`${choosenEducationType === "bachelors" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Bachelors</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="masters"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="masters"
                                                                    checked={choosenEducationType === "masters"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="masters" className={`${choosenEducationType === "masters" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Masters</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="doctorate-or-phd"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="doctorate-or-phd"
                                                                    checked={choosenEducationType === "doctorate-or-phd"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="doctorate-or-phd" className={`${choosenEducationType === "doctorate-or-phd" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Doctorate or P.hd</div>
                                                                </label>
                                                            </div>

                                                            <div className="education-outer">
                                                                <input type="radio"
                                                                    id="prefer-not-to-answer"
                                                                    name="choosen-education-type"
                                                                    className="hidden"
                                                                    value="prefer-not-to-answer"
                                                                    checked={choosenEducationType === "prefer-not-to-answer"}
                                                                    onChange={onOptionChange}
                                                                />
                                                                <label htmlFor="prefer-not-to-answer" className={`${choosenEducationType === "prefer-not-to-answer" ? 'active' : ''}`}>
                                                                    <div className="mb-2 heading-part">Prefer not to answer</div>
                                                                </label>
                                                            </div>

                                                        </div>
                                                    </Col>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={educationFieldsOne}>Back</Button>
                                                                <Button className='my-next-btn button-green float-end' onClick={educationFieldsThree}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }

                                {
                                    educationTabThree ?
                                        <Card.Body className='education-part-three-main'>
                                            <Row>
                                                <Col md={12} className='education-part-three-text-outer'>
                                                    <div className='education-part-three-text'>
                                                        <h2>Tell me about your education</h2>
                                                        <p>Enter your education experience so far, even if you are a current student or did not graduate.</p>
                                                    </div>
                                                </Col>

                                                <Col md={12} className='mt-3'>
                                                    <Form>
                                                        {
                                                            loader ? <SpinLoader /> :
                                                                education.length > 0 ?

                                                                    education.map((field, index) => (
                                                                        <Row className='job-infromation-part' key={index}>

                                                                            <Col md={6} className="mb-3">
                                                                                <label className="form-label">School Name<span className="fa fa-star requierd-star"></span></label>
                                                                                <input
                                                                                    placeholder="Enter the school Name"
                                                                                    type="text"
                                                                                    name='schoolName'
                                                                                    className="form-control form-control-lg"
                                                                                    value={field.schoolName || ''}
                                                                                    onChange={(event) => handleChange(index, event)}
                                                                                />
                                                                                {
                                                                                    field?.errorSchoolNameMsg ? <span className='text-danger'>{field?.errorSchoolNameMsg}</span> : ''
                                                                                }
                                                                            </Col>
                                                                            <Col md={6} className="mb-3">
                                                                                <label className="form-label">School Location<span className="fa fa-star requierd-star"></span></label>
                                                                                <input
                                                                                    placeholder="Enter the school location"
                                                                                    type="text"
                                                                                    name="schoolLocation"
                                                                                    className="form-control form-control-lg"
                                                                                    value={field.schoolLocation}
                                                                                    onChange={(event) => handleChange(index, event)}
                                                                                />
                                                                                {
                                                                                    field?.errorSchoolLocationMsg ? <span className='text-danger'>{field?.errorSchoolLocationMsg}</span> : ''
                                                                                }
                                                                            </Col>
                                                                            <Col md={6} className="mb-3">
                                                                                <label className="form-label">Degree<span className="fa fa-star requierd-star"></span></label>
                                                                                <input
                                                                                    placeholder="Enter the degree"
                                                                                    type="text"
                                                                                    name="schoolDegree"
                                                                                    className="form-control form-control-lg"
                                                                                    value={field.schoolDegree}
                                                                                    onChange={(event) => handleChange(index, event)}
                                                                                />
                                                                                {
                                                                                    field?.errorSchoolDegreeMsg ? <span className='text-danger'>{field?.errorSchoolDegreeMsg}</span> : ''
                                                                                }
                                                                            </Col>
                                                                            <Col md={6} className="mb-3">
                                                                                <label className="form-label">Field of Study<span className="fa fa-star requierd-star"></span></label>
                                                                                <input
                                                                                    placeholder="Enter the field of study"
                                                                                    type="text"
                                                                                    name="schoolFieldOfStudy"
                                                                                    className="form-control form-control-lg"
                                                                                    value={field.schoolFieldOfStudy}
                                                                                    onChange={(event) => handleChange(index, event)}
                                                                                />
                                                                                {
                                                                                    field?.errorSchoolFieldOfStudyMsg ? <span className='text-danger'>{field?.errorSchoolFieldOfStudyMsg}</span> : ''
                                                                                }
                                                                            </Col>
                                                                            <Col md={6} className="mb-3">
                                                                                <label className="form-label">Year of completion<span className="fa fa-star requierd-star"></span></label>
                                                                                <select
                                                                                    className="form-select form-control form-control-lg education-year"
                                                                                    name="schoolYearOfCompletion"
                                                                                    onChange={(event) => handleChange(index, event)}
                                                                                    value={field.schoolYearOfCompletion} >
                                                                                    <option value='' >Select a year</option>
                                                                                    {
                                                                                        years.map((year, index) => (
                                                                                            <option value={year} key={index}>{year}</option>
                                                                                        ))
                                                                                    }
                                                                                </select>

                                                                                {
                                                                                    field?.errorSchoolYearOfCompletionMsg ? <span className='text-danger'>{field?.errorSchoolYearOfCompletionMsg}</span> : ''
                                                                                }
                                                                            </Col>
                                                                            {
                                                                                education.length > 1 ?
                                                                                    <Button variant="outline-danger remove-education-button" onClick={() => handelEducationRemove(index)}><i className="fa fa-trash" aria-hidden="true"></i></Button>
                                                                                    : ''
                                                                            }
                                                                        </Row>
                                                                    ))

                                                                    : 
                                                                        // <> You need to add your Education to your Poppin’ Jobs Profile. <i className="fa fa-external-link custom-pointer" aria-hidden="true" onClick={moveToPoppinAppJobForm}></i>
                                                                        <> Click the <strong>Add Education</strong> button to include your educational details here.
                                                                    </>
                                                        }
                                                    </Form>
                                                </Col>

                                                <Col md={12} className='mt-3'>
                                                    <Button className='add-education-button' onClick={handelEducationAdd}><i className="fa fa-plus" aria-hidden="true"></i> Add Education</Button>
                                                </Col>

                                                <Col md={12}>
                                                    <Col className='next-prev-btn-section col-md-12'>
                                                        <Row>
                                                            <Col md={12} className='form-mid-section'>
                                                                <Button className='my-previous-btn float-start' onClick={educationFieldsTwo}>Back</Button>
                                                                <Button className='my-next-btn button-green float-end' onClick={MovetoSkillPage}>Next</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                        : ''
                                }
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section >

        </>
    )
}

export default Education
